import gql from 'graphql-tag';

const notificationsQuery = gql`
  query notificationsQuery($page: Int!, $pageSize: Int!) {
    notificationFeed(page: $page, pageSize: $pageSize) {
      items {
        id
        read
        type
        date
        purchaseName
        event {
          id
          name
          image {
            md
          }
        }
        purchase {
          id
        }
        comment {
          body
        }
        actor {
          id
          name
          type
          avatarUrls {
            sm
            md
          }
        }
        subject {
          id
          uuid
          name
          type
        }
        comment {
          body
        }
        verbMeta {
          amount
          comment
          recipientId
          recipientName
          userTokenUuid
        }
      }
      unreadCount
    }
  }
`;

const unreadNotificationCountQuery = gql`
  query unreadNotificationCountQuery {
    notificationUnreadCounts {
      unreadCounts {
        entityId
        entityType
        unreadCount
      }
    }
  }
`;

const markNotificationReadMutation = gql`
  mutation markNotificationRead($id: Int!) {
    markNotificationRead(notificationId: $id) {
      success
    }
  }
`;

const markAllNotificationsReadV2Mutation = gql`
  mutation markAllNotificationsRead {
    markAllNotificationsRead {
      success
    }
  }
`;

export {
  notificationsQuery,
  unreadNotificationCountQuery,
  markNotificationReadMutation,
  markAllNotificationsReadV2Mutation,
};
